// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import {
    ScrollView,
    StyleSheet,
    View,
    ActivityIndicator,
    Text,
} from "react-native";
import colors from "../../config/colors";
import { Snackbar } from "react-native-paper";
import TransportCard from "../../components/Shadows/Carrier/TransportCard";
import ActiveRequestDetail from "../../components/Shadows/Carrier/ActiveRequestDetail";
import {
    fetchActiveTransferGroup,
    fetchVechicleList,
} from "../../axios/axiosConfig";

const MovementScreen = ({
    formatDate,
    getTranslation,
    loginStatus,
    fetchActiveRequests,
}) => {
    const [responseData, setResponseData] = useState(null);
    const [activeTransportData, setActiveTransportData] = useState(null);
    //const [vehicles, setVehicles] = useState(null);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarColor, setSnackbarColor] = useState(colors.green);
    const [collapsed, setIsCollapsed] = useState(true);
    const [reload, setReload] = useState(true);
    //const [defaultVehicle, setDefaultVehicle] = useState(null);
    const [loadingTimeout, setLoadingTimeout] = useState(false);

    function handleReload() {
        setReload(!reload);
    }

    const fetchData = async () => {
        try {
            const transportResponse = await fetchActiveTransferGroup();
            
            if (transportResponse.status === 200) {
                const apiArray = [transportResponse.data.data];
                setResponseData(apiArray);
                setActiveTransportData(transportResponse.data);
            }
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        fetchData();
        fetchActiveRequests();
    }, [reload]);

    const handleShowSnackbar = (value, color) => {
        setSnackbarMessage(value);
        setSnackbarColor(color);
    };

    const handleCollapsedHeader = (value) => {
        setIsCollapsed(value);
    };

    const renderTransportCards = () => {
        if (
            Array.isArray(activeTransportData) &&
            activeTransportData.length > 0 
        ) {
            const data = activeTransportData[0]?.data;
            if (Array.isArray(data)) {
                return data.map((transport, index) => (
                    <TransportCard
                        key={transport.id}
                        transportId={transport.id}
                        status={transport.status}
                        startDate={transport.startDate}
                        getTranslation={getTranslation}
                        plannedDate={formatDate(transport.plannedDate)}
                        qta={transport?.quantity || transport.plannedQuantity}
                        sub={transport?.dryMaterialPercentage || "-"}
                        MaterialName={transport.contentType}
                        isFromSharedDeposit={transport.isFromSharedDeposit}
                        addressFrom={transport.from}
                        addressTo={transport.to}
                        ownerFromType={transport.from.ownerType}
                        fromHasToInsertQuantity={transport.from.hasQuantityCheck}
                        toHasToInsertQuantity={transport.to.hasQuantityCheck}
                        ownerTypeTo={transport.to.ownerType}
                        handleShowSnackbar={handleShowSnackbar}
                        plannedQuantity={transport.plannedQuantity}
                        handleReload={handleReload}
                        emptyForContentType={transport?.emptyForContentType}
                        fetchActiveRequests={fetchActiveRequests}
                    />
                ));
            }
        }
    };

    return (
        <>
            {loadingTimeout ? (
                <View style={styles.loadingContainer}>
                    <Text style={{ color: colors.white, fontSize: 18 }}>
                        Nothing to do here, please select a request to start working.
                    </Text>
                </View>
            ) : activeTransportData ? (
                <ScrollView style={styles.container}>
                    <View>
                        {activeTransportData && (
                            <View>
                                <ActiveRequestDetail
                                    getTranslation={getTranslation}
                                    handleCollapsedHeader={handleCollapsedHeader}
                                    isCollapsed={collapsed}
                                    activeTransportData={activeTransportData}
                                />
                            </View>
                        )}
                    </View>
                    {activeTransportData?.data == null && !collapsed ? (
                        <View style={styles.loadingContainer}></View>
                    ) : (
                        <View>{renderTransportCards()}</View>
                    )}
                </ScrollView>
            ) : (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator size="large" color={colors.white} />
                </View>
            )}
            <Snackbar
                visible={snackbarMessage !== ""}
                onDismiss={() => setSnackbarMessage("")}
                duration={3000}
                action={{
                    label: "OK",
                    labelStyle: { color: "white" },
                    onPress: () => setSnackbarMessage(""),
                }}
                style={{ backgroundColor: snackbarColor, color: "white" }}
            >
                {snackbarMessage}
            </Snackbar>
        </>
    );
};

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 10,
        paddingVertical: 5,
        backgroundColor: colors.green,
    },
    tableContainer: {
        backgroundColor: colors.green,
        marginBottom: 10,
    },
    loadingContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colors.green,
        color: colors.white,
        fontWeight: "bold",
    },
});

export default MovementScreen;
